import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
const bioMatrixScanVuex = createNamespacedHelpers("bioMatrixScan");
export default {
  name: "popFaceScanLog",
  props: {},
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "tonConnect"]),
    ...userVuex.mapState(["userData"]),
    ...bioMatrixScanVuex.mapState(["faceUidLogList", "faceUidLogHasMore", "faceUidLogLoading", "faceUidLogCondition", "faceUidLogTotal"])
  },
  data() {
    return {};
  },
  watch: {
    "$parent.popFaceScanLogShow": {
      handler(bool) {
        if (bool) {
          this.onLoadData(1);
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    await this.getFaceUidLogList();
  },
  methods: {
    ...bioMatrixScanVuex.mapActions(["getFaceUidLogList"]),
    ...bioMatrixScanVuex.mapMutations(["setFaceUidLogCondition"]),
    checkScroll() {
      const scrollHeight = this.$refs.myScroll.scrollHeight;
      const scrollTop = this.$refs.myScroll.scrollTop;
      const clientHeight = this.$refs.myScroll.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        // 接近底部时触发加载  
        if (this.faceUidLogHasMore && !this.faceUidLogLoading) {
          this.onLoadData(this.faceUidLogCondition.page + 1);
        }
      }
    },
    async onLoadData(page) {
      this.setFaceUidLogCondition({
        "limit": 20,
        "page": page
      });
      await this.getFaceUidLogList();
    }
  }
};